import { useCallback, useState } from "react";
import { MethodsProps } from "../store/modules/parameter/types";
import { ReactCreditCardProps, UserCard } from "../store/modules/auth/types";
import { methodFavorite, methodRemove, setPayOnDelivery } from "../store/modules/parameter/actions";
import { useDispatch } from "react-redux";

export const usePaymentMethod = () => {
    const dispatch = useDispatch();
    const [methodSelected, setMethod] = useState<MethodsProps>({} as MethodsProps);
    const [values, setValues] = useState<ReactCreditCardProps>({} as ReactCreditCardProps);
    const [openViewCreatePayment, setOpenViewCreatePayment] = useState(false);

    const handledSetMethod = useCallback((methodSel: MethodsProps) => {
        setMethod(methodSel);
        return;
    }, [setMethod]);

    const onSetOpenViewCreatePayment = useCallback(() => {
        setOpenViewCreatePayment(v => !v);
    }, [setOpenViewCreatePayment]);

    const handledMethodEdit = useCallback((method: UserCard) => {
        setValues({
            id: method.id ? method.id : 0,
            name: method.full_name ? method.full_name : '',
            expiration: method.expiry_date ? method.expiry_date : '',
            number: method.card_number ? method.card_number : '',
            cvc: method.cvc ? method.cvc : '',
            cardLastFour: method.card_last_four ? method.card_last_four : '',
            customer_doc: method.customer_doc ? method.customer_doc : '',
            type: method.card_brand ? method.card_brand : '',
        });
        if (method.media_id) {
            handledSetMethod({
                media_id: method.media_id,
                method: method.method as string,
            });
        }
        else {
            setMethod({} as MethodsProps);
        }
        onSetOpenViewCreatePayment();
    }, [setValues, handledSetMethod, onSetOpenViewCreatePayment]);

    const handledMethodAdd = useCallback(() => {
        setValues({
            id: 0,
            name: '',
            expiration: '',
            number: '',
            cvc: '',
            cardLastFour: '',
            customer_doc: '',
            type: '',
        })
        setMethod({} as MethodsProps);
        onSetOpenViewCreatePayment();
    }, [setValues, onSetOpenViewCreatePayment]);

    const handledMethodRemove = useCallback((method_id: number) => {
        //konsole.log('handledMethodRemove(): ', method_id);
        dispatch(methodRemove(method_id));
    }, [dispatch]);

    const handledMethodFavorite = useCallback((methodId: number, mediaId: number) => {
        //konsole.log('handledMethodFavorite(): ', method_id);
        // if (handledSetMethodSelectExt)
        //     handledSetMethodSelectExt(methodId, mediaId);
        dispatch(methodFavorite(methodId));
    }, [dispatch]);

    const handledPayOnDelivery = useCallback(() => {
        dispatch(setPayOnDelivery());
    }, [dispatch]);

    return {
        methodSelected,
        handledSetMethod,
        handledMethodAdd,
        handledMethodEdit,
        handledMethodRemove,
        handledMethodFavorite,
        handledPayOnDelivery,
        onSetOpenViewCreatePayment,
        values,
        openViewCreatePayment,
    }
}